import React from "react";

const LogoutIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.8108 11.9166C13.3017 11.9166 12.8902 12.3273 12.8902 12.8332V16.5C12.8902 17.0051 12.4776 17.4166 11.9693 17.4166H9.20717V3.66661C9.20717 2.88377 8.70629 2.18436 7.9532 1.92403L7.68059 1.83322H11.9693C12.4776 1.83322 12.8902 2.24478 12.8902 2.75V5.5C12.8902 6.00589 13.3017 6.41661 13.8108 6.41661C14.32 6.41661 14.7315 6.00589 14.7315 5.5V2.75C14.7315 1.23384 13.4922 0 11.9693 0H2.07163C2.03656 0 2.00723 0.0156098 1.97317 0.0201416C1.92883 0.016449 1.88652 0 1.8415 0C0.825919 0 0 0.822113 0 1.83322V18.3332C0 19.1161 0.500879 19.8155 1.25397 20.0758L6.79499 21.9147C6.9828 21.9725 7.1696 22 7.36584 22C8.38142 22 9.20717 21.1777 9.20717 20.1666V19.25H11.9693C13.4922 19.25 14.7315 18.0162 14.7315 16.5V12.8332C14.7315 12.3273 14.32 11.9166 13.8108 11.9166Z"
        fill="currentColor"
      />
      <path
        d="M21.827 8.51747L18.144 4.85086C17.8808 4.58869 17.4848 4.5098 17.1406 4.6518C16.7971 4.79396 16.5724 5.12848 16.5724 5.49892V8.24892H12.8896C12.3813 8.24892 11.9688 8.65947 11.9688 9.16553C11.9688 9.67159 12.3813 10.0821 12.8896 10.0821H16.5724V12.8321C16.5724 13.2026 16.7971 13.5371 17.1406 13.6793C17.4848 13.8213 17.8808 13.7424 18.144 13.4804L21.827 9.81359C22.187 9.45523 22.187 8.87583 21.827 8.51747Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LogoutIcon;
